import type { DataItem as ProductsConfirmStepNewAirRoadCustomTableDataItem } from '@/components/customTables/ProductsConfirmStepNewAirRoadCustomTable.vue';
import type * as openapi from '@/helpers/api/types/openapiOverrides';

import { getStrCell } from '@/utils/file';

export function getTableItem(
  item: Required<openapi.AirroadSingleCreateBodyOpenapi['items'][0]>,
  num: number,
): ProductsConfirmStepNewAirRoadCustomTableDataItem {
  return {
    _id: item.products.map((product) => product.product_id).join(','),
    num,
    type: getStrCell(item.item_type),
    volume: getStrCell(item.volume),
    weight: getStrCell(item.weight),
  };
}

export function getTableData(
  items: openapi.AirroadSingleCreateBodyOpenapi['items'] | undefined,
): ProductsConfirmStepNewAirRoadCustomTableDataItem[] {
  let num = 0;
  const _productsConfirmStepNewAirRoadTableData: ProductsConfirmStepNewAirRoadCustomTableDataItem[] =
    [];
  if (!items?.length) return _productsConfirmStepNewAirRoadTableData;
  items.forEach((item) => {
    num = num + 1;
    if (!item.products) return;
    // @ts-expect-error TODO item.products and Required<openapi.AirroadSingleCreateBodyOpenapi['items'][0]>
    _productsConfirmStepNewAirRoadTableData.push(getTableItem(item, num));
  });
  return _productsConfirmStepNewAirRoadTableData;
}
